import {Component, input} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HlmSidebarImports} from '@spartan-ng/helm/sidebar';
import {Sidebar} from './components/sidebar/sidebar';
import {Breadcrumb} from './components/breadcrumb/breadcrumb';
import {LanguageSwitcher} from './components/language-switcher/language-switcher';

@Component({
  imports: [RouterOutlet, HlmSidebarImports, Sidebar, Breadcrumb, LanguageSwitcher],
  selector: 'app-sidebar-layout',
  template: `
    <app-sidebar>
      <main hlmSidebarInset class="min-w-0">
        <header class="flex h-15 items-center justify-between px-6 border-b">
          <div class="flex gap-2 items-center">
            <button hlmSidebarTrigger><span class="sr-only"></span></button>
            @if (showBreadcrumb()) {
              <app-breadcrumb />
            }
          </div>
          @if (showLanguageSwitcher()) {
            <app-language-switcher />
          }
        </header>
        @if (isNew()) {
          <div class="p-6">
            <router-outlet></router-outlet>
          </div>
        } @else {
          <div class="bs-legacy">
            <div class="az-body az-body-sidebar">
              <div class="az-content az-content-dashboard-two">
                <div class="relative overflow-y-visible p-4">
                  <router-outlet></router-outlet>
                </div>
              </div>
            </div>
          </div>
        }
      </main>
    </app-sidebar>
  `,
})
export class SidebarLayout {
  showLanguageSwitcher = input<boolean>(false);
  showBreadcrumb = input<boolean>(false);
  isNew = input<boolean>(false); // TODO: remove this logic after bootstrap removed
}
